import script from "./MaterialOrderList.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialOrderList.vue?vue&type=script&setup=true&lang=js"

import "./MaterialOrderList.vue?vue&type=style&index=0&id=cafd0030&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cafd0030"]])

export default __exports__